<div class="d-grid">
  <button
    type="button"
    [ngClass]="buttonClass"
    (click)="generateFloor()"
    [disabled]="_disabled"
  >
    {{ buttonTitle }}
  </button>
</div>
